
import { find } from 'lodash';
import { Photo } from '../../types/documentRequirements';
import { isVideoMimeType } from '../../components/file-upload/FileUploadTypes';
import { VideoStatusId } from '../../types/s3Storage';
import { isNotApplicablePhoto } from '../Utils';

const MEDIA_REQUIREMENT_TYPES = ['PHOTO', 'VIDEO'];

export const isMediaRequirementType = (requirementTypeId: string): boolean => {
    return MEDIA_REQUIREMENT_TYPES.includes(requirementTypeId);
};

export const getRequirementTypeDisplay = (requirementTypeId: string) => {
    if (requirementTypeId === 'VIDEO') {
        return 'Video';
    }
    if (requirementTypeId === 'PHOTO') {
        return 'Photo';
    }
    return requirementTypeId;
};

export const hasVideoRequirement = (requirements): boolean => {
    const found = find(requirements, req => req.requirementTypeId === 'VIDEO');
    return !!found;
};

const isVideo = (p: Photo): boolean =>
    isVideoMimeType(p?.requirement?.mimeType || '');

const isCompleteVideo = photo =>
    isVideo(photo) &&
    photo.requirement?.video?.statusId === VideoStatusId.COMPLETE ||
    photo.requirement?.thumbnail?.statusId === VideoStatusId.COMPLETE;

export const isAllowToEditRequirementType = (
    media: Photo,
    enabledVideo: boolean
): boolean => {
    if (isVideo(media)) {
        if (!isCompleteVideo(media)) {
            return false;
        }
        return true;
    }
    return true;
};
